import { BRAND, COUNTRY_SWEDEN_ID, COUNTRY_UAE_ID } from "./constants"

const sv_privacy_policy = `
<div class="container mx-auto p-8">
  <h1 class="text-4xl font-bold mb-4">Integritetspolicy</h1>
  <p class="mb-4">Investoract värnar om din integritet. Denna policy beskriver vilken information vi samlar in, hur vi använder den och vilka åtgärder vi vidtar för att skydda den.</p>
  
  <h2 class="text-2xl font-semibold mb-2">Information vi Samlar In</h2>
  <p class="mb-4"><strong>Personuppgifter:</strong> Vi kan samla in personuppgifter såsom ditt namn, e-postadress och telefonnummer när du registrerar dig eller kontaktar oss.</p>
  <p class="mb-4"><strong>Användningsdata:</strong> Vi använder Google Analytics för att samla in information om hur du använder vår webbplats, inklusive din IP-adress, webbläsartyp och besökta sidor.</p>

  <h2 class="text-2xl font-semibold mb-2">Användning av Information</h2>
  <p class="mb-4"><strong>Personuppgifter:</strong> Används för att svara på dina förfrågningar, tillhandahålla kundsupport och förbättra våra tjänster.</p>
  <p class="mb-4"><strong>Användningsdata:</strong> Används för att analysera webbplatstrafik och förbättra användarupplevelsen.</p>

  <h2 class="text-2xl font-semibold mb-2">Cookies</h2>
  <p class="mb-4">Vår webbplats använder cookies för att förbättra din upplevelse. Du kan inaktivera cookies genom dina webbläsarinställningar, men vissa funktioner kanske inte fungerar korrekt.</p>

  <h2 class="text-2xl font-semibold mb-2">Datasäkerhet</h2>
  <p class="mb-4">Vi implementerar säkerhetsåtgärder för att skydda din information. Inget överföringssätt över Internet är dock helt säkert.</p>

  <h2 class="text-2xl font-semibold mb-2">Tredjepartstjänster</h2>
  <p class="mb-4">Vi kan dela din information med tredjepartstjänster som Google Analytics för att analysera webbplatstrafik.</p>

  <h2 class="text-2xl font-semibold mb-2">Ändringar i Integritetspolicyn</h2>
  <p class="mb-4">Vi kan uppdatera denna policy från tid till annan. Ändringar kommer att publiceras på denna sida.</p>

  <h2 class="text-2xl font-semibold mb-2">Kontaktinformation</h2>
  <p>Om du har några frågor om denna Integritetspolicy, vänligen kontakta oss på <a href="mailto:info@investoract.com" class="text-blue-500 hover:underline">info@investoract.com</a>.</p>
</div>
`
const sv_terms_of_use = `
<div class="container mx-auto p-8">
  <h1 class="text-4xl font-bold mb-4">Användarvillkor</h1>
  <p class="mb-4">Välkommen till Börs360. Genom att besöka eller använda vår webbplats godkänner du att följa och vara bunden av följande villkor.</p>
  
  <h2 class="text-2xl font-semibold mb-2">Användning av Webbplatsen</h2>
  <p class="mb-4">Du godkänner att använda webbplatsen endast för lagliga ändamål. Du får inte bryta mot eller försöka bryta mot webbplatsens säkerhet.</p>

  <h2 class="text-2xl font-semibold mb-2">Immateriella Rättigheter</h2>
  <p class="mb-4">Allt innehåll på webbplatsen, inklusive text, grafik, logotyper och bilder, tillhör Börs360 och är skyddat av upphovsrättslagar.</p>

  <h2 class="text-2xl font-semibold mb-2">Användarinnehåll</h2>
  <p class="mb-4">Du behåller äganderätten till allt innehåll du publicerar på webbplatsen, men du ger Börs360 en licens att använda, visa och distribuera ditt innehåll.</p>

  <h2 class="text-2xl font-semibold mb-2">Ansvarsbegränsning</h2>
  <p class="mb-4">Börs360 är inte ansvarig för direkta, indirekta, oavsiktliga eller följdskador som uppstår från användningen av webbplatsen.</p>

  <h2 class="text-2xl font-semibold mb-2">Ändringar av Villkor</h2>
  <p class="mb-4">Vi förbehåller oss rätten att ändra dessa villkor när som helst. Din fortsatta användning av webbplatsen innebär att du accepterar de nya villkoren.</p>

  <h2 class="text-2xl font-semibold mb-2">Kontaktinformation</h2>
  <p>Om du har några frågor om dessa Användarvillkor, vänligen kontakta oss på <a href="mailto:info@bors360.com" class="text-blue-500 hover:underline">info@investoract.com</a>.</p>
</div>
`

const en_privacy_policy = `
<div class="container mx-auto p-8">
  <h1 class="text-4xl font-bold mb-4">Privacy Policy</h1>
  <p class="mb-4">Investoract values your privacy. This policy outlines the information we collect, how we use it, and the steps we take to ensure it is protected.</p>
  
  <h2 class="text-2xl font-semibold mb-2">Information We Collect</h2>
  <p class="mb-4"><strong>Personal Information:</strong> We may collect personal information such as your name, email address, and phone number when you register or contact us.</p>
  <p class="mb-4"><strong>Usage Data:</strong> We use Google Analytics to collect information about how you use our website, including your IP address, browser type, and pages visited.</p>

  <h2 class="text-2xl font-semibold mb-2">Use of Information</h2>
  <p class="mb-4"><strong>Personal Information:</strong> Used to respond to your inquiries, provide customer support, and improve our services.</p>
  <p class="mb-4"><strong>Usage Data:</strong> Used to analyze website traffic and improve user experience.</p>

  <h2 class="text-2xl font-semibold mb-2">Cookies</h2>
  <p class="mb-4">Our website uses cookies to enhance your experience. You can disable cookies through your browser settings, but some features may not function properly.</p>

  <h2 class="text-2xl font-semibold mb-2">Data Security</h2>
  <p class="mb-4">We implement security measures to protect your information. However, no method of transmission over the Internet is completely secure.</p>

  <h2 class="text-2xl font-semibold mb-2">Third-Party Services</h2>
  <p class="mb-4">We may share your information with third-party services like Google Analytics to analyze web traffic.</p>

  <h2 class="text-2xl font-semibold mb-2">Changes to Privacy Policy</h2>
  <p class="mb-4">We may update this policy from time to time. Changes will be posted on this page.</p>

  <h2 class="text-2xl font-semibold mb-2">Contact Information</h2>
  <p>If you have any questions about this Privacy Policy, please contact us at <a href="mailto:info@investoract.com" class="text-blue-500 hover:underline">info@investoract.com</a>.</p>
</div>
`

const en_terms_of_use = `
<div class="container mx-auto p-8">
  <h1 class="text-4xl font-bold mb-4">Terms of Use</h1>
  <p class="mb-4">Welcome to Investoract. By accessing or using our website, you agree to comply with and be bound by the following terms and conditions.</p>
  
  <h2 class="text-2xl font-semibold mb-2">Use of the Website</h2>
  <p class="mb-4">You agree to use the website only for lawful purposes. You are prohibited from violating or attempting to violate the security of the website.</p>

  <h2 class="text-2xl font-semibold mb-2">Intellectual Property</h2>
  <p class="mb-4">All content on the website, including text, graphics, logos, and images, is the property of Investoract and is protected by copyright laws.</p>

  <h2 class="text-2xl font-semibold mb-2">User Content</h2>
  <p class="mb-4">You retain ownership of any content you post on the website, but you grant Investoract a license to use, display, and distribute your content.</p>

  <h2 class="text-2xl font-semibold mb-2">Limitation of Liability</h2>
  <p class="mb-4">Investoract is not liable for any direct, indirect, incidental, or consequential damages arising from the use of the website.</p>

  <h2 class="text-2xl font-semibold mb-2">Changes to Terms</h2>
  <p class="mb-4">We reserve the right to modify these terms at any time. Your continued use of the website constitutes acceptance of the new terms.</p>

  <h2 class="text-2xl font-semibold mb-2">Contact Information</h2>
  <p>If you have any questions about these Terms of Use, please contact us at <a href="mailto:info@investoract.com" class="text-blue-500 hover:underline">info@investoract.com</a>.</p>
</div>
`

const sv = {
  '1month': '1 månad',
  '1week': '1 vecka',
  '1year': '1 år',
  '3months': '3 månader',
  '3years': '3 år',
  '5years': '5 år',
  '6months': '6 månader',
  'allInsights': 'Alla nyheter',
  'about': 'Om',
  'attachedDocument': 'Bifogad dokument',
  'bookmark__reactionAdded': 'Reaktion tillagd',
  'bookmark__reactionRemoved': 'Reaktion borttagen',
  'bookmark__reactions': 'Reaktioner',
  'commentedOn': 'Kommenterade på',
  'country': 'Land',
  'filterInsightsOnSector': 'Utforska sektorer',
  'goToAllInsights': 'Gå till alla nyheter',
  'insight': 'Insikt',
  'instrument__searchBy': 'Sök på namn, isin eller ticker',
  'isin': 'ISIN',
  'latestPressreleaseSummariesFrom': 'Senaste sammanfattade pressmeddelande från',
  'latestStockPrice': 'Senaste aktiekurs',
  'latestDisclosures': 'Senaste nyheter',
  'login__enterLoginCredentials': 'Ange dina inloggningsuppgifter',
  'login__enterYourPassword': 'Ange lösenord',
  'login__enterYourUsername': 'Ange användarnamn',
  'login__login': 'Logga in',
  'login__password': 'Lösenord',
  'login__username': 'Användarnamn',
  'login_alreadyHaveAnAccount': 'Har du redan ett konto?',
  'login_clickHereToLogin': 'Klicka här för att logga in!',
  'login_createANewAccount': `Skapa konto nu!`,
  'login_dontHaveAnAccount': `Har du inget konto?`,
  'login_to_react': 'Logga in för att reagera!',
  'logout_success': 'Utloggad. Hoppas att du kommer tillbaka snart.',
  'logout': 'Logga ut',
  'market': 'Marknad',
  'name': 'Namn',
  'newsUpdateFrom': 'Nyhetsuppdatering från',
  'next': 'Nästa',
  'noArticles': 'Inga artiklar funna',
  'noData': 'Ingen information funnen',
  'noDisclosures': 'Inga nyheter funna.',
  'noInstruments': 'Inga aktier',
  'noMoreArticles': 'Inga fler artiklar',
  'noMoreData': 'Ingen mer information',
  'noMoreDisclosures': 'Inga fler nyheter.',
  'noMoreInstruments': 'Inga fler aktier',
  'noMorePortfolios': 'Inga fler portföljer',
  'noMoreThreads': 'Inga fler kommentarer',
  'noMoreTransactions': 'Inga fler transaktioner',
  'noNews': 'Inga nyheter funna',
  'noNoreNews': 'Inga fler nyheter',
  'noPortfolios': 'Inga portföljer funna',
  'noThreads': 'Inga kommentarer',
  'noTransactions': 'Inga transaktioner',
  'page': 'Sida',
  'popularNews': 'Populära Nyheter',
  'portfolio': 'Portfölj',
  'pressreleaseAnalysis': 'Nyheter',
  'previous': 'Föregående',
  'privacyPolicyHTML': sv_privacy_policy,
  'readAllInsights': 'Utforska alla nyheter',
  'readMoreAbout': 'Läs mer om',
  'regarding': 'gällande',
  'relatedArticles': 'Relaterade nyheter',
  'report': 'Rapport',
  'search': 'Sök',
  'sector': 'Sektor',
  'source': 'Källa',
  'startPage__subTitle': `Först med de senaste finansnyheter.`,
  'startPage__title': `Senaste nytt`,
  'summary': 'Sammanfattning',
  'technicalAnalysis': 'Teknisk analys',
  'termsOfUseHTML': sv_terms_of_use,
  'ticker': 'Ticker',
  'transaction': 'Transaktion',
  'ytd': 'Hittills i år',
  'landingPage__description': <>
    <h2>Investera i den <strong>svenska börsen</strong> med aktuell finansinformation</h2>
    <p>På <strong>Börs360</strong> hjälper vi dig att hålla dig uppdaterad med den senaste utvecklingen på <strong>aktiemarknaden</strong> och <strong>finansmarknaden</strong> i Sverige. Vårt mål är att erbjuda den mest tillförlitliga <strong>finansinformationen</strong> och detaljerade <strong>finansiella analyser</strong> som hjälper dig att fatta välgrundade investeringsbeslut. Genom att kombinera <strong>finansnyheter</strong>, <strong>finansiella rapporter</strong> och realtidsuppdateringar av aktiedata, får du en <strong>heltäckande överblick</strong> över marknadens rörelser och trender.</p>
    <p>Oavsett om du är en <strong>erfaren investerare</strong> eller nybörjare som vill investera på börsen, ger vi dig verktygen och insikterna för att analysera olika finansiella instrument och strategier. Med våra <strong>skräddarsydda artiklar</strong> och <strong>djupgående analyser</strong> kan du navigera den svenska <strong>finansmarknaden</strong> med självförtroende.</p>
  </>,


}

const en = {
  '1month': '1 month',
  '1week': '1 week',
  '1year': '1 year',
  '3months': '3 months',
  '3years': '3 years',
  '5years': '5 years',
  '6months': '6 months',
  'allInsights': 'All news',
  'about': 'About',
  'attachedDocument': 'Attached Document',
  'bookmark__reactionAdded': 'Reaction Added',
  'bookmark__reactionRemoved': 'Reaction Removed',
  'bookmark__reactions': 'Reactions',
  'commentedOn': 'Commented on',
  'country': 'Country',
  'filterInsightsOnSector': 'Explore Sectors',
  'goToAllInsights': 'Go to all insights',
  'insight': 'Insight',
  'instrument__searchBy': 'Search By name, isin or ticker',
  'isin': 'ISIN',
  'latestPressreleaseSummariesFrom': 'Latest Pressrelease Summaries from',
  'latestStockPrice': 'Latest Stock Price',
  'latestDisclosures': 'Latest Disclosures',
  'login__enterLoginCredentials': 'Enter your login credentials',
  'login__enterYourPassword': 'Enter your password',
  'login__enterYourUsername': 'Enter your username',
  'login__login': 'Login',
  'login__password': 'Password',
  'login__username': 'Enter your username',
  'login_alreadyHaveAnAccount': 'Already have an account?',
  'login_clickHereToLogin': 'Click here to login!',
  'login_createANewAccount': `Create an account now!`,
  'login_dontHaveAnAccount': `Don't have an account?`,
  'login_to_react': 'Please login to react!',
  'logout_success': 'Successfully logged out. Hope to see you again soon.',
  'logout': 'Logout',
  'market': 'Market',
  'name': 'Name',
  'newsUpdateFrom': 'News Update From',
  'next': 'Next',
  'noArticles': 'No articles found',
  'noData': 'No data',
  'noDisclosures': 'No disclosures found. Have a look in a couple of days',
  'noInstruments': 'No instruments found',
  'noMoreArticles': 'No more articles',
  'noMoreData': 'No more data',
  'noMoreDisclosures': 'No more disclosures. Have a look in a couple of days',
  'noMoreInstruments': 'No more instruments',
  'noMorePortfolios': 'No more portfolios',
  'noMoreThreads': 'No more threads',
  'noMoreTransactions': 'No more transactions',
  'noPortfolios': 'No portfolios found',
  'noThreads': 'No threads found. Be the first to add a thread',
  'noTransactions': 'No transactions',
  'page': 'Page',
  'popularNews': 'Popular Insights',
  'portfolio': 'Portfolio',
  'pressreleaseAnalysis': 'News',
  'previous': 'Previous',
  'privacyPolicyHTML': en_privacy_policy,
  'readAllInsights': 'Explore all Insights',
  'readMoreAbout': 'Read more about',
  'regarding': 'regarding',
  'relatedArticles': 'Related articles',
  'report': 'Report',
  'search': 'Search',
  'sector': 'Sector',
  'source': 'Source',
  'startPage__subTitle': `Your number one resource for the latest financial news in U.A.E.`,
  'startPage__title': `Latest Insights`,
  'summary': 'Summary',
  'technicalAnalysis': 'Technical analysis',
  'termsOfUseHTML': en_terms_of_use,
  'ticker': 'Ticker',
  'transaction': 'Transaction',
  'ytd': 'Year to date',
  'landingPage__description': <>
    <h2>Empowering Investors with Comprehensive Financial Information in the UAE</h2>
    <p>At <strong>InvestorAct</strong>, we provide up-to-date insights into the <strong>stock market</strong> and <strong>financial market</strong> in the <strong>UAE</strong>, covering both <strong>Dubai</strong> and <strong>Abu Dhabi</strong>. Our mission is to deliver reliable <strong>financial information</strong> and in-depth <strong>financial analysis</strong> to help you make informed investment decisions. With access to the latest <strong>financial news</strong>, detailed <strong>financial reports</strong>, and real-time <strong>financial data</strong>, you can stay ahead of market trends and developments.</p>
    
    <p>Whether you're a seasoned <strong>investor</strong> or new to the <strong>finance</strong> world, we offer the tools and insights needed to evaluate various <strong>financial instruments</strong> and strategies. Through our tailored articles and in-depth reports, you'll be equipped to navigate the UAE's dynamic <strong>financial market</strong> with confidence.</p>
  </>
}

const translateIt = (lang, key) => {
  if (typeof (lang) == 'number') {
    if (lang == COUNTRY_SWEDEN_ID) {
      lang = 'sv'
    } else if (lang == COUNTRY_UAE_ID) {
      lang = 'en'
    } else {
      lang = 'en'
    }
  }

  let translations = {}
  if (lang == 'sv') {
    translations = sv
  } else {
    translations = en
  }
  const translated = translations[key]
  return translated || key
}

export { translateIt }
